import moment from "moment";
import { Component } from "react";
import { injectIntl } from "react-intl";
import { intlShape } from "../../shapes";

import { Details, DetailsItem } from "../Details";
import { Clue } from "../Clue";
import { redirectTo, displayUserName, isNumber } from "../../utils";
import { cardPaymentDetailsShape } from "../../shapes/cardPaymentDetailsShape";
import { invoicePaymentDetailsShape } from "../../shapes/invoicePaymentDetailsShape";
import SubscriptionPaymentEditModal from "./SubscriptionPaymentEditModal";
import ConfirmationModal from "../ConfirmationModal";

const CARD_NAMES = {
  visa: "Visa",
  mastercard: "MasterCard",
  american_express: "American Express",
  discover: "Discover",
  jcb: "JCB",
  diners_club: "Diner's Club",
};

type Props = {
  cardPaymentDetails?: cardPaymentDetailsShape;
  invoicePaymentDetails?: invoicePaymentDetailsShape;
  source: string;
  assetId?: number;
  intl: intlShape;
  onChangeToPaymentPerInvoice?: $TSFixMeFunction;
  canChangeToInvoice: boolean;
};

type State = $TSFixMe;

class SubscriptionPaymentDetails extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    /* istanbul ignore next */
    this.onPaymentEditAccept = this.onPaymentEditAccept.bind(this);
    this.onPaymentEditDecline = this.onPaymentEditDecline.bind(this);
    this.onPaymentUpdateToInvoice = this.onPaymentUpdateToInvoice.bind(this);
    this.onChangeToPaymentPerInvoiceAccept =
      this.onChangeToPaymentPerInvoiceAccept.bind(this);
    this.onChangeToPaymentPerInvoiceDecline =
      this.onChangeToPaymentPerInvoiceDecline.bind(this);
    this.state = {
      showPaymentEditModal: false,
      showUpdatePaymentModal: false,
    };
  }

  onChangeToPaymentPerInvoiceAccept() {
    this.setState({ showUpdatePaymentModal: false });
    // @ts-expect-error TS(2722) FIXME: Cannot invoke an object which is possibly 'undefin... Remove this comment to see the full error message
    this.props.onChangeToPaymentPerInvoice();
  }

  onChangeToPaymentPerInvoiceDecline() {
    this.setState({ showUpdatePaymentModal: false });
  }

  onPaymentUpdateToInvoice() {
    this.setState({
      showPaymentEditModal: false,
      showUpdatePaymentModal: true,
    });
  }

  onPaymentEditDecline() {
    this.setState({ showPaymentEditModal: false });
  }

  onPaymentEditAccept() {
    const { source, assetId } = this.props;
    const assetIdSuffix = isNumber(assetId) ? `/${assetId}` : "";
    this.setState({ showPaymentEditModal: false });
    redirectTo(`/payment/update/${source}${assetIdSuffix}`);
  }

  render() {
    const {
      cardPaymentDetails,
      intl,
      invoicePaymentDetails,
      canChangeToInvoice,
    } = this.props;
    const { showPaymentEditModal, showUpdatePaymentModal } = this.state;
    if (invoicePaymentDetails) {
      return (
        <Details>
          <DetailsItem
            // @ts-expect-error TS(2322) FIXME: Type '{ intl: intlShape; id: string; translationKe... Remove this comment to see the full error message
            intl={intl}
            id="payment-details-payment-method-per-invoice"
            translationKey="subscription.payment_method.header"
            value={intl.formatMessage({
              id: "subscription.payment_method.invoice",
            })}
          />
        </Details>
      );
    }
    if (cardPaymentDetails && cardPaymentDetails.valid) {
      const card = intl.formatMessage(
        { id: "payment_details.card" },
        {
          // @ts-expect-error TS(2538) FIXME: Type 'undefined' cannot be used as an index type.
          name: CARD_NAMES[cardPaymentDetails.type],
          ending: cardPaymentDetails.identifier,
        },
      );
      const validUntil = moment(
        `${cardPaymentDetails.expiryYear}-${cardPaymentDetails.expiryMonth}-01`,
        "YYYY-MM-DD",
      ).format("MM/YYYY");
      return (
        <Details>
          <DetailsItem
            // @ts-expect-error TS(2322) FIXME: Type '{ intl: intlShape; id: string; translationKe... Remove this comment to see the full error message
            intl={intl}
            id="payment-details-payment-method-per-credit-card"
            translationKey="subscription.payment_method.header"
            value={intl.formatMessage({
              id: "subscription.payment_method.credit_card",
            })}
          />
          <DetailsItem
            // @ts-expect-error TS(2322) FIXME: Type '{ intl: intlShape; id: string; translationKe... Remove this comment to see the full error message
            intl={intl}
            id="payment-details-card-holder"
            translationKey="label.card_holder"
            value={displayUserName(cardPaymentDetails)}
          />
          <DetailsItem
            // @ts-expect-error TS(2322) FIXME: Type '{ intl: intlShape; id: string; translationKe... Remove this comment to see the full error message
            intl={intl}
            id="payment-details-card"
            translationKey="label.credit_card"
            value={card}
          />
          <DetailsItem
            // @ts-expect-error TS(2322) FIXME: Type '{ intl: intlShape; id: string; translationKe... Remove this comment to see the full error message
            intl={intl}
            id="payment-details-card-expiry"
            translationKey="label.valid_until"
            value={validUntil}
          />
        </Details>
      );
    }

    const modalChangeToInvoice = (
      <ConfirmationModal
        id="modal-dialog-invoice"
        show={showUpdatePaymentModal}
        titleText={intl.formatMessage({
          id: "payment_details_edit.change_credit_to_invoice",
        })}
        messageText={intl.formatMessage({
          id: "payment_details_edit.change_to_invoice_description",
        })}
        onConfirm={this.onChangeToPaymentPerInvoiceAccept}
        onClose={this.onChangeToPaymentPerInvoiceDecline}
      />
    );

    const paymentEditModal = showPaymentEditModal ? (
      <SubscriptionPaymentEditModal
        onAccept={this.onPaymentEditAccept}
        onDecline={this.onPaymentEditDecline}
        onChange={this.onPaymentUpdateToInvoice}
        isCredit={cardPaymentDetails !== null}
        canChangeToInvoice={canChangeToInvoice}
      />
    ) : null;
    return (
      <div>
        {paymentEditModal}
        {modalChangeToInvoice}
        <Clue
          id="payment-invalid-clue"
          title={intl.formatMessage({ id: "payment_details.invalid.header" })}
          details={intl.formatMessage({
            id: "payment_details.invalid.description",
          })}
          action={intl.formatMessage({ id: "payment_details.invalid.button" })}
          onClick={() => this.setState({ showPaymentEditModal: true })}
          highlighted
        />
      </div>
    );
  }
}

export default injectIntl(SubscriptionPaymentDetails);
